// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var financeRouter = {
  path: '/finance',
  component: Layout,
  redirect: '/finance',
  name: 'Financial',
  meta: {
    title: '财务',
    icon: 'clipboard'
  },
  children: [{
    path: 'statement',
    name: 'FinanceStatement',
    meta: {
      title: '账单管理',
      noCache: true
    },
    component: function component() {
      return import('@/views/finance/statement/index');
    }
  }, {
    path: 'closingSetting',
    component: function component() {
      return import('@/views/finance/setting/index');
    },
    name: 'ClosingSetting',
    meta: {
      title: '商户结算设置',
      icon: ''
    }
  }, {
    path: 'closing',
    component: function component() {
      return import('@/views/finance/closing/index');
    },
    name: 'FinancialClosing',
    meta: {
      title: '结算管理',
      icon: ''
    },
    alwaysShow: true,
    children: [{
      path: 'merchantClosing',
      component: function component() {
        return import('@/views/finance/closing/merchantClosing/index');
      },
      name: 'MerchantClosing',
      meta: {
        title: '商户结算',
        icon: ''
      }
    }, {
      path: 'userClosing',
      component: function component() {
        return import('@/views/finance/closing/userClosing/index');
      },
      name: 'UserClosing',
      meta: {
        title: '用户结算',
        icon: ''
      }
    }]
  }, {
    path: 'charge',
    component: function component() {
      return import('@/views/finance/charge/index');
    },
    name: 'FinanceCharge',
    meta: {
      title: '充值记录',
      icon: ''
    }
  }, {
    path: 'wallet',
    component: function component() {
      return import('@/views/finance/wallet/index');
    },
    name: 'FinanceWallet',
    meta: {
      title: '积分管理',
      icon: ''
    },
    alwaysShow: true,
    children: [{
      path: 'agentWallet',
      component: function component() {
        return import('@/views/finance/wallet/agentWallet/index');
      },
      name: 'FinanceAgentWallet',
      meta: {
        title: '平台积分',
        noCache: true
      }
    }, {
      path: 'agentUserWallet',
      component: function component() {
        return import('@/views/finance/wallet/agentUserWallet/index');
      },
      name: 'FinanceAgentUserWallet',
      meta: {
        title: '用户积分',
        icon: ''
      }
    }, {
      path: 'agentWalletFlow',
      component: function component() {
        return import('@/views/finance/wallet/agentWalletFlow/index');
      },
      name: 'FinanceAgentWalletFlow',
      meta: {
        title: '用户积分明细',
        icon: ''
      }
    }, {
      path: 'agentWalletPlatformFlow',
      component: function component() {
        return import('@/views/finance/wallet/agentWalletPlatformFlow/index');
      },
      name: 'FinanceAgentWalletPlatformFlow',
      meta: {
        title: '平台积分明细',
        icon: ''
      }
    }, {
      path: 'agentWalletConfig',
      component: function component() {
        return import('@/views/finance/wallet/agentWalletConfig/index');
      },
      name: 'FinanceAgentWalletConfig',
      meta: {
        title: '积分配置',
        icon: ''
      }
    }, {
      path: 'agentWalletWhite',
      component: function component() {
        return import('@/views/finance/wallet/agentWalletWhite/index');
      },
      name: 'FinanceAgentWalletWhite',
      meta: {
        title: '积分转账白名单',
        icon: ''
      }
    }]
  }, {
    path: 'journalAccount',
    component: function component() {
      return import('@/views/finance/journalAccount/index');
    },
    name: 'FinanceJournalAccount',
    meta: {
      title: '流水管理',
      icon: ''
    },
    alwaysShow: true,
    children: [{
      path: 'capitalFlow',
      name: 'FinanceCapitalFlow',
      meta: {
        title: '资金流水',
        noCache: true
      },
      component: function component() {
        return import('@/views/finance/journalAccount/capitalFlow/index');
      }
    }, {
      path: 'summaryCapitalFlow',
      component: function component() {
        return import('@/views/finance/journalAccount/summaryCapitalFlow/index');
      },
      name: 'SummaryCapitalFlow',
      meta: {
        title: '流水汇总',
        icon: ''
      }
    }]
  }, {
    path: 'provide',
    component: function component() {
      return import('@/views/finance/provide/index');
    },
    name: 'FinanceProvide',
    meta: {
      title: '佣金管理',
      icon: ''
    },
    children: [{
      path: 'provideconfig',
      component: function component() {
        return import('@/views/finance/provide/provideconfig/index');
      },
      name: 'ProvideConfig',
      meta: {
        title: '出款配置',
        icon: ''
      }
    }, {
      path: 'providerecord',
      component: function component() {
        return import('@/views/finance/provide/providerecord/index');
      },
      name: 'ProvideRecord',
      meta: {
        title: '出款管理',
        icon: ''
      }
    }]
  }, {
    path: 'withdraw',
    component: function component() {
      return import('@/views/finance/withdraw/index');
    },
    name: 'FinanceWithdraw',
    meta: {
      title: '钱包提现',
      icon: ''
    }
  }, {
    path: 'card',
    component: function component() {
      return import('@/views/finance/card/index');
    },
    name: 'FinanceCard',
    meta: {
      title: '银行卡',
      icon: ''
    }
  },, {
    path: 'jd',
    component: function component() {
      return import('@/views/finance/jd/index');
    },
    name: 'FinanceJd',
    meta: {
      title: '京东管理',
      icon: ''
    },
    children: [{
      path: 'drawConfig',
      component: function component() {
        return import('@/views/finance/jd/drawconfig/index');
      },
      name: 'drawConfig',
      meta: {
        title: '提现列表',
        icon: ''
      }
    }, {
      path: 'jdConfig',
      component: function component() {
        return import('@/views/finance/jd/jdconfig/index');
      },
      name: 'ProvideRecord',
      meta: {
        title: '京东账户',
        icon: ''
      }
    }]
  }, {
    path: 'xf',
    component: function component() {
      return import('@/views/finance/xf/index');
    },
    name: 'FinanceXf',
    meta: {
      title: '小福管理',
      icon: ''
    },
    children: [{
      path: 'xfConfig',
      component: function component() {
        return import('@/views/finance/xf/xfconfig/index');
      },
      name: 'xfConfig',
      meta: {
        title: '小福订单',
        icon: ''
      }
    }, {
      path: 'xfsettleConfig',
      component: function component() {
        return import('@/views/finance/xf/xfsettleconfig/index');
      },
      name: 'xfsettleConfig',
      meta: {
        title: '小福佣金',
        icon: ''
      }
    }]
  }, {
    path: 'pay',
    component: function component() {
      return import('@/views/finance/pay/index');
    },
    name: 'FinancePay',
    meta: {
      title: '支付管理',
      icon: ''
    },
    children: [{
      path: 'yopwechat',
      component: function component() {
        return import('@/views/finance/pay/yopwechat/index');
      },
      name: 'YopWechatManagement',
      meta: {
        title: '易宝微信授权与AppID',
        icon: ''
      }
    }, {
      path: 'paychannel',
      component: function component() {
        return import('@/views/finance/pay/paychannel/index');
      },
      name: 'paychannel',
      meta: {
        title: '支付渠道',
        icon: ''
      }
    }, {
      path: 'payCompany',
      component: function component() {
        return import('@/views/finance/pay/paycompany/index');
      },
      name: 'payCompany',
      meta: {
        title: '付款公司资料信息',
        icon: ''
      }
    }, {
      path: 'paymerchant',
      component: function component() {
        return import('@/views/finance/pay/paymerchant/index');
      },
      name: 'paymerchant',
      meta: {
        title: '支付进件子商户',
        icon: ''
      }
    }, {
      path: 'payuser',
      component: function component() {
        return import('@/views/finance/pay/payuser/index');
      },
      name: 'payuser',
      meta: {
        title: '收款用户',
        icon: ''
      }
    }, {
      path: 'payusermerchant',
      component: function component() {
        return import('@/views/finance/pay/payusermerchant/index');
      },
      name: 'payusermerchant',
      meta: {
        title: '收款用户子商户进件绑定关系',
        icon: ''
      }
    }, {
      path: 'payorder',
      component: function component() {
        return import('@/views/finance/pay/payorder/index');
      },
      name: 'payorder',
      meta: {
        title: '支付订单',
        icon: ''
      }
    }, {
      path: 'payrefundorder',
      component: function component() {
        return import('@/views/finance/pay/payorder/reindex');
      },
      name: 'payrefundorder',
      meta: {
        title: '退款订单',
        icon: ''
      }
    }, {
      path: 'paytsindex',
      component: function component() {
        return import('@/views/finance/pay/payts/index');
      },
      name: 'paytsindex',
      meta: {
        title: '投诉订单',
        icon: ''
      }
    }]
  }]
};
export default financeRouter;